export const wrapperList = [
  {
    id: 1,
    img: "https://res.cloudinary.com/ironbike/image/upload/v1650738552/Main/tower-electric-bikes-dU9rbaVIIns-unsplash_am5ljc.jpg",
    title: "NEW COLLECTION",
    description: "YOUR SEASON STARTS NOW.",
  },
  {
    id: 2,
    img: "https://res.cloudinary.com/ironbike/image/upload/v1650738552/Main/kenny-eliason-tokYjYqaPB0-unsplash_ccialh.jpg",
    title: "FLY LIKE A BIRD",
    description: "THE BEST PRODUCTS AND THE BEST PRICE.",
  },
  {
    id: 3,
    img: "https://res.cloudinary.com/ironbike/image/upload/v1649974553/Main/155b6941-5192-4841-976d-bcbc0c486fdf-reward_hnthzy.jpg",
    title: "TRAVEL FAR",
    description: "DISCOVER BIKEPACKING PRODUCTS.",
  },
];
export const categories = [
  {
    id: 1,
    img: "https://res.cloudinary.com/ironbike/image/upload/v1650271363/Products/Bike/Road%20Bike/FOCUS_Izalco_Max_8_9_petrol_610x610_dvhovx.jpg",
    title: "BIKES ",
    categories: "Bikes",
  },
  {
    id: 2,
    img: "https://res.cloudinary.com/ironbike/image/upload/v1650012282/Products/Nutrition/Drinks/olimp-sport-nutrition-vita-min-plus-e1574409697684_pibm9q.jpg",
    title: "SPORT NUTRITION",
    categories: "Nutrition",
  },
  {
    id: 3,
    img: "https://res.cloudinary.com/ironbike/image/upload/v1649969624/Products/Clothes/600x600-170684_15687106786451_auwldb.jpg",
    title: "RIDERS GEAR",
    categories: "Clothes",
  },
  {
    id: 4,
    img: "https://res.cloudinary.com/ironbike/image/upload/v1650369818/Main/devices_k23nqi.png",
    title: "ACCESSORY",
    categories: "Accessory",
  },
];




